<template>
<div>
    <vue-headful title="Registrations :: MeritEHS" />

    <h4 class="py-3 mb-4">
        <ol class="breadcrumb font-weight-bold m-0">
            <li class="breadcrumb-item font-weight-light">
                <router-link :to="`/subcontractors`">
                    <i class="fa fa-id-badge"></i> Subcontractors
                </router-link>
            </li>
            <li class="breadcrumb-item font-weight-light">
                <router-link :to="`/subcontractors/settings#prequalification`">
                    Settings - Business Registrations
                </router-link>
            </li>
            <li class="breadcrumb-item active">Edit</li>
        </ol>
    </h4>
    <template v-if="!done_loading">
        <i class="fa fa-circle-o-notch fa-spin"></i> Loading
    </template>
    <template v-else>
        <div class="card mb-3">
            <div class="card-header">
                <strong>Edit Business Registrations</strong>
            </div>
            <div class="card-body">
                <div class="alert alert-info">
                    If no states are selected, all states will be displayed as possible business registrations
                </div>
                <b-row>
                    <b-col>
                        <div v-for="p in pcol1">
                            <b-form-checkbox v-model="p['status']" unchecked-value=0 value=1 plain>
                                {{ p.state_name }}
                            </b-form-checkbox>
                        </div>
                    </b-col>
                    <b-col>
                        <div v-for="p in pcol2">
                            <b-form-checkbox v-model="p['status']" unchecked-value=0 value=1 plain>
                                {{ p.state_name }}
                            </b-form-checkbox>
                        </div>
                    </b-col>
                    <b-col>
                        <div v-for="p in pcol3">
                            <b-form-checkbox v-model="p['status']" unchecked-value=0 value=1 plain>
                                {{ p.state_name }}
                            </b-form-checkbox>
                        </div>
                    </b-col>
                </b-row>
            </div>
        </div>

        <b-button size="sm" variant="success" @click="saveRegistrations" :disabled="saving">
            <template v-if="saving">
                <i class="fa fa-spinner fa-pulse"></i> Saving
            </template>
            <template v-else>
                Save
            </template>
        </b-button>
    </template>
</div>
</template>

<script>
export default {
    data: function() {
        return {
            done_loading: false,
            saving: false,
            registrations: [],
            count_per_column: 0,
            pcol1: [],
            pcol2: [],
            pcol3: [],
            errors: {},
        }
    },

    computed: {

    },

    methods: {
        getRegistrations: function() {
            //Get the data
            this.$http
                .get('subcontractors/registration-edit')
                .then(response => {
                    //Set all the data
                    this.registrations = response.data;
                    this.count_per_column = Math.ceil(this.registrations.length / 3);
                    if (this.count_per_column >= 4) {
                        var ix = 0;
                        for (var x = 0; x < this.count_per_column; ++x) {
                            this.pcol1.push(this.registrations[ix]);
                            ix++;
                        }
                        for (var x = 0; x < this.count_per_column; ++x) {
                            this.pcol2.push(this.registrations[ix]);
                            ix++;
                        }
                        for (var x = 0; x < this.count_per_column; ++x) {
                            if (this.registrations[ix]) {
                                this.pcol3.push(this.registrations[ix]);
                                ix++;
                            }
                        }
                    }
                })
                .catch(response => {
                    //How to handle the error
                })
                .then(() => {
                    //Set loading
                    this.done_loading = true;
                });
        },

        saveRegistrations() {
            //Saving
            this.saving = true;

            var retval = [];

            this.pcol1.forEach((p) => {
                if (p['status'] == 1) {
                    retval.push(p['state_id']);
                }
            });
            this.pcol2.forEach((p) => {
                if (p['status'] == 1) {
                    retval.push(p['state_id']);
                }
            });
            this.pcol3.forEach((p) => {
                if (p['status'] == 1) {
                    retval.push(p['state_id']);
                }
            });

            this.$http
                .post('subcontractors/registration-edit', {
                    'data': retval
                })
                .then(response => {
                    //Alert the user?
                    this.$toastr.success('Business Registrations Saved');

                    this.$router.push('/subcontractors/settings#prequalification');
                })
                .catch(error => {
                    //Check for error
                    if (error.response.status === 422) {
                        //Display validation errors
                        this.errors = error.response.data
                    }
                })
                .then(response => {
                    //SHow loading
                    this.saving = false;
                });
        },
    },

    mounted() {
        //Get the injuries
        this.getRegistrations();
    }
}
</script>
